import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import TableContainer from '@material-ui/core/TableContainer';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const StyledAccordion = styled(Accordion)<{fixedtopmargin?: number}>`
    ${props => props?.fixedtopmargin ? ('margin-top: 16px;') : ''}
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
    padding: 0;
`;

export const StyledAccordionSummary = styled(AccordionSummary)<{completed?: number}>`
    background-color: ${props => props?.completed ? '#ddfada' : '#ffe6e5'};
`;

export const StyledTableContainer = styled(TableContainer)`
    border-top: 1px solid rgba(224, 224, 224, 1);
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: rgb(224, 224, 224);
`;

export const TypographySecondary = styled(Typography)`
    width: 100%;
    text-align: right;
    color: rgba(0, 0, 0, 0.75);
`;
